import arduino from 'highlight.js/lib/languages/arduino';
import bash from 'highlight.js/lib/languages/bash';
import c from 'highlight.js/lib/languages/c';
import cpp from 'highlight.js/lib/languages/cpp';
import csharp from 'highlight.js/lib/languages/csharp';
import css from 'highlight.js/lib/languages/css';
import diff from 'highlight.js/lib/languages/diff';
import go from 'highlight.js/lib/languages/go';
// import graphql from 'highlight.js/lib/languages/graphql'
import ini from 'highlight.js/lib/languages/ini';
import java from 'highlight.js/lib/languages/java';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import kotlin from 'highlight.js/lib/languages/kotlin';
import less from 'highlight.js/lib/languages/less';
import lua from 'highlight.js/lib/languages/lua';
import makefile from 'highlight.js/lib/languages/makefile';
import markdown from 'highlight.js/lib/languages/markdown';
import objectivec from 'highlight.js/lib/languages/objectivec';
import perl from 'highlight.js/lib/languages/perl';
import php from 'highlight.js/lib/languages/php';
import phpTemplate from 'highlight.js/lib/languages/php-template';
import plaintext from 'highlight.js/lib/languages/plaintext';
import python from 'highlight.js/lib/languages/python';
import pythonRepl from 'highlight.js/lib/languages/python-repl';
import r from 'highlight.js/lib/languages/r';
import ruby from 'highlight.js/lib/languages/ruby';
import rust from 'highlight.js/lib/languages/rust';
import scss from 'highlight.js/lib/languages/scss';
import shell from 'highlight.js/lib/languages/shell';
import sql from 'highlight.js/lib/languages/sql';
import swift from 'highlight.js/lib/languages/swift';
import typescript from 'highlight.js/lib/languages/typescript';
import vbnet from 'highlight.js/lib/languages/vbnet';
// import wasm from 'highlight.js/lib/languages/wasm'
import xml from 'highlight.js/lib/languages/xml';
import yaml from 'highlight.js/lib/languages/yaml';
import lowlight from 'lowlight/lib/core.js';
import ReactLowlight from 'react-lowlight';
const init = () => {
    ReactLowlight.registerLanguage('arduino', arduino);
    ReactLowlight.registerLanguage('bash', bash);
    ReactLowlight.registerLanguage('c', c);
    ReactLowlight.registerLanguage('cpp', cpp);
    ReactLowlight.registerLanguage('csharp', csharp);
    ReactLowlight.registerLanguage('css', css);
    ReactLowlight.registerLanguage('diff', diff);
    ReactLowlight.registerLanguage('go', go);
    // ReactLowlight.registerLanguage('graphql', graphql)
    ReactLowlight.registerLanguage('html', xml);
    ReactLowlight.registerLanguage('ini', ini);
    ReactLowlight.registerLanguage('java', java);
    ReactLowlight.registerLanguage('javascript', javascript);
    ReactLowlight.registerLanguage('json', json);
    ReactLowlight.registerLanguage('kotlin', kotlin);
    ReactLowlight.registerLanguage('less', less);
    ReactLowlight.registerLanguage('lua', lua);
    ReactLowlight.registerLanguage('makefile', makefile);
    ReactLowlight.registerLanguage('markdown', markdown);
    ReactLowlight.registerLanguage('objectivec', objectivec);
    ReactLowlight.registerLanguage('perl', perl);
    ReactLowlight.registerLanguage('php', php);
    ReactLowlight.registerLanguage('php-template', phpTemplate);
    ReactLowlight.registerLanguage('plaintext', plaintext);
    ReactLowlight.registerLanguage('python', python);
    ReactLowlight.registerLanguage('python-repl', pythonRepl);
    ReactLowlight.registerLanguage('r', r);
    ReactLowlight.registerLanguage('ruby', ruby);
    ReactLowlight.registerLanguage('rust', rust);
    ReactLowlight.registerLanguage('scss', scss);
    ReactLowlight.registerLanguage('shell', shell);
    ReactLowlight.registerLanguage('sql', sql);
    ReactLowlight.registerLanguage('swift', swift);
    ReactLowlight.registerLanguage('typescript', typescript);
    ReactLowlight.registerLanguage('vbnet', vbnet);
    // ReactLowlight.registerLanguage('wasm', wasm)
    ReactLowlight.registerLanguage('xml', xml);
    ReactLowlight.registerLanguage('yaml', yaml);
};
export { lowlight, ReactLowlight, init };
//# sourceMappingURL=lowlight.js.map